/* jshint ignore:start */
import axios from "axios";
let cancel;
let CancelToken = axios.CancelToken;

export const loadArchive = (form, content) => {
  let wrapper = content.find('.wrapper-archive-body-wrapper');
  wrapper.html('');

  wrapper.addClass('isLoading');

  if (cancel != undefined) {
    cancel();
  }

  // Remove /page/X/ from pathname to reset pagination when filtering/searching
  let pathname = window.location.pathname.replace(/\/page\/\d+\/?/, '/');
  let origin = `${window.location.origin}${pathname}`;
  let url = new URL(origin);
  let calendar_el = $('.SessieZoeken');
  const datas = form.find('input:visible, select:visible').serializeArray();
  console.log(datas);
  const datas_obj = {};
  datas.map(data => datas_obj[data.name] = data.value);

  // const datas = form.serializeArray().concat(attributes);

  datas.forEach(data => {
    if (data.name === 'view' && data.value === 'calendar') {
      datas.push({
        name: 'cal_date',
        value: $('.current_date').length > 0 ? $('.current_date').data('date') : (new Date()).toISOString().slice(0, 10),
      })
      calendar_el.show();
    } else if (data.name === 'view' && data.value !== 'calendar') {
      calendar_el.hide();
    }
  });

  datas.forEach(data => {
    if (!jQuery.isEmptyObject(data) && data.value !== '') {
      url.searchParams.append(data.name, data.value);
    }
  });

  if (typeof window.calendar !== 'undefined') {
    if ((datas_obj.view || '') === 'calendar') {
      let sources = window.calendar.getEventSources();
      let the_source = sources[0];
      let eventSource = the_source.internalEventSource;

      eventSource.meta.extraParams = datas_obj;
      window.calendar.refetchEvents()
    }
  }

  history.pushState({}, null, url);

  const formData = new FormData();
  formData.append('ajax', true);
  $('.sidebar-filtered-results-count').text('');
  $('.filter-count').text('');

  $('body').on('click', '.remove-filters', function () {
    $('.filter-count').text('');
  })

  axios({
    method: 'post',
    url: url,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
    data: formData,
    headers: {
      'Content-type': 'application/json',
    },
  }).then(res => {
    wrapper.removeClass('isLoading');
    content.find('.wrapper-archive-body-wrapper').html(res.data);
    if (content.find('.wrapper-archive-body-total-found').length > 0) {
      let updatedval = content.find('.wrapper-archive-body-total-found').attr('data-count');
      $('.sidebar-filtered-results-count').text('(' + updatedval + ')');
    }

    let filterCount = datas.filter(function (item) {
      if ((item.name === 'view' && item.value !== 'list')) {
        return true;
      }

      if ((item.name === 'type' && item.value !== 'groepssessie')) {
        return true;
      }

      if ((item.name === 'price_min' && item.value !== '0')) {
        return true;
      }

      if ((item.name === 'price_max' && item.value !== '2500')) {
        return true;
      }

      if ((item.name === 'search' && item.value !== '')) {
        return true;
      }

      return false;
    });

    if (filterCount.length > 0) {
      $('.filter-count').text('(' + filterCount.length + ')');
      $('.remove-filters').show();
    }

  }).catch((err) => {
    if (axios.isCancel(err)) {
      console.log('Canceled');
      return;
    }
    wrapper.removeClass('isLoading');
    content.find('.wrapper-archive-body-wrapper').html('<div class="wrapper-archive-body-items-container" id="archive-content">Niks gevonden.</div>');
  });
}



// WEBPACK FOOTER //
// ./scripts/modules/archive.js